import * as types from '../mutation-types'

// state
export const state = {
    left_open: getLocalStorage('show_sidebar') == 'true',
    preloader: true,
}

// mutations
export const mutations = {
    [types.LEFT_MENU] (state, option) {
        if (option == "init") {
            state.left_open = getLocalStorage('show_sidebar') == 'true'
            return;
        }

        if (option == "open") {
            state.left_open = true
        } else if (option == "close") {
            state.left_open = false
        } else if (option == "toggle") {
            state.left_open = !state.left_open
        }
        setLocalStorage('show_sidebar', state.left_open)
    },

    [types.ROUTE_CHANGE] (state, loader) {
        if (loader == "start") {
            state.preloader = true
        } else if (loader == "end") {
            state.preloader = false
        }
    }
}

// Handle chocolate chip cookies
function setLocalStorage(name, value) {
    localStorage.setItem(name, value)
    return value
}

// Only custom for this
function getLocalStorage(name) {
    return localStorage.getItem(name)
}
